import { render, staticRenderFns } from "./Politique.vue?vue&type=template&id=7b191852&scoped=true"
import script from "./Politique.vue?vue&type=script&lang=js"
export * from "./Politique.vue?vue&type=script&lang=js"
import style0 from "./Politique.vue?vue&type=style&index=0&id=7b191852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../app/browser@vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b191852",
  null
  
)

export default component.exports